module.exports = __webpack_public_path__ + "static/media/testimonials.ee14ad48.png";